import { defineComponent, inject, provide, ref, shallowRef } from 'vue'
import { ElDialog } from 'element-plus'
import { addUnit } from '../_util'
import { modalContextKey, modalLocatorContextKey, ModalOptions } from './types'

const Modal = defineComponent({
  name: 'OModal',
  setup(props, { slots, attrs, emit, expose }) {
    const modalLocator = inject(modalLocatorContextKey)

    const show = ref(false)
    const title = ref<string>()
    const content = shallowRef()
    const contentProps = ref<Record<string, any>>()
    const width = ref<number | string>()
    const height = ref<number | string>()
    const __resolve = ref<(value: Record<string, any> | PromiseLike<Record<string, any>>) => void>()
    const showClose = ref(true)
    const appendTo = ref<HTMLElement>()

    const _open: (options: ModalOptions) => Promise<Record<string, any>> = async (options) => {
      show.value = true
      title.value = options.title
      content.value = options.content
      if (options.contentProps) {
        contentProps.value = options.contentProps
      } else {
        contentProps.value = {}
      }
      if (options.width) {
        width.value = options.width
      }
      if (options.height) {
        height.value = addUnit(options.height)
      }
      if (options.showClose != undefined && options.showClose == false) {
        showClose.value = false
      }
      if (options.locator) {
        appendTo.value = options.locator
      } else {
        if (modalLocator && modalLocator.locator.value) {
          appendTo.value = modalLocator.locator.value
        }
      }

      const promise = new Promise<Record<string, any>>((resolve, reject) => {
        __resolve.value = resolve
      })

      return promise
    }
    expose({
      open: _open,
    })

    const _close: (options: Record<string, any>) => void = (options) => {
      const resolve = __resolve.value

      show.value = false
      title.value = undefined
      content.value = undefined
      contentProps.value = undefined
      width.value = undefined
      height.value = undefined
      __resolve.value = undefined
      showClose.value = true
      appendTo.value = undefined

      resolve && resolve(options)
    }
    provide(modalContextKey, { close: _close })

    return () => {
      const Children = content.value
      return show.value ? (
        <ElDialog
          class={title.value ? 'orion-dialog' : 'orion-dialog notitle'}
          modal-class="orion-dialog-overlay"
          title={title.value}
          width={width.value}
          modelValue={show.value}
          beforeClose={_close}
          draggable={true}
          closeOnClickModal={false}
          closeOnPressEscape={false}
          showClose={showClose.value}
          alignCenter={true}
          style={{ height: height.value }}
          appendTo={appendTo.value}
        >
          <Children {...contentProps.value}></Children>
        </ElDialog>
      ) : (
        <></>
      )
    }
  },
})

export default Modal
